import { Schema as S } from "effect";

export const GetTiSettingsItemSchema = S.Struct({
  _id: S.String,
  authenticationEnabled: S.Boolean,
  authenticationType: S.String,
  basicAuthPassword: S.String,
  basicAuthUsername: S.String,
  checkSubscriptionIntervalMinutes: S.Int,
  clientCertificateBase64String: S.String,
  clientCertificateName: S.String,
  clientCertificatePassword: S.String,
  connectorFQDN: S.String,
  erpIdpClientId: S.String,
  erpIdpEndpoint: S.String,
  erpIdpRedirectURI: S.String,
  erpServiceFQDN: S.String,
  eventingCertificateBase64String: S.String,
  eventingCertificateEnabled: S.Boolean,
  eventingCertificateName: S.String,
  eventingCertificatePassword: S.String,
  eventingEnabled: S.Boolean,
  konnektorCertificatesOrdered: S.Array(S.Unknown),
  modeOnlineCheck: S.String,
  publicCetpHost: S.String,
  selectedDeviceServerProxy: S.String,
  tlsEnabled: S.Boolean,
  useDeviceServerProxy: S.Boolean,
  useOwnClientSystemId: S.Boolean,
  cetpHost: S.String,
  cetpPort: S.Int,
  publicCetpPort: S.Int,
  puppetryClientSystemId: S.String,
  creationDate: S.String,
});

export const GetTiSettingsMetaSchema = S.Struct({
  errors: S.Array(S.Unknown),
  warnings: S.Array(S.Unknown),
  query: S.Record(S.String, S.Unknown),
  itemsPerPage: S.NullOr(S.Number),
  totalItems: S.Int,
  page: S.NullOr(S.Number),
  replyCode: S.Int,
  model: S.Literal("cardreader"),
});

export const GetTiSettingsResponseSchema = S.Array(GetTiSettingsItemSchema);

export type GetTiSettingsResponse = S.Schema.Type<typeof GetTiSettingsResponseSchema>;
